window.RemovalReasonForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            removalReasonForm: '#removal-reason-form',
            messages: {
                invalidCheckboxError: '#removal-reason-form-error',
                invalidDateError: '#removal-reason-form-invalid-date-message'
            },
            selectBox: {
                removalReasonSelect: '#removal-reason-form-select-'
            },
            checkBox: {
                confirmCheck: '#removal-reason-form-check'
            },
            button: {
                continue: '#removal-reason-form-continue'
            },
            hiddenField:{
                dependantCount: '#removal-reason-form-dependant-count',
                deceasedDescription: '#removal-reason-form-deceased-description'
            },
            textBox:{
                dayId: '#removal-reason-form-day',
                monthId: '#removal-reason-form-month',
                yearId: '#removal-reason-form-year'
            }
        },
        css: {
            invalidCheckbox: 'vds-checkbox--invalid',
            confirmCheckContainer: '#removal-reason-form-check-container',
            dateOfDeceased: '.date-of-deceased',
            removalReason: '.removal-reason-select',
            invalidDeceasedDateErrorMessage: '.invalid-deceased-date',
            invalidTextBoxError : 'vds-form__input--invalid',
            deceasedDay : '.deceased-day',
            deceasedMonth : '.deceased-month',
            deceasedYear : '.deceased-year'
        },
        urls: {
            requestSubmittedPage:'/my-health-insurance/manage-my-plan/manage-members/remove-members/request-submitted',
            errorPageUrl: '/error/error-page',
            sendRemovalReasonFormDetails: '/api/sitecore/RemoveMembers/SendRemovalReasonFormDetails'
        },
        statusDescription: {
            accepted: 'accepted',
            badRequest: 'badrequest'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidCheckboxError).hide();
                $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                $(self.css.dateOfDeceased).hide();
                $(self.css.invalidDeceasedDateErrorMessage).hide();
            },
            bindings: function () {
                $(self.elements.checkBox.confirmCheck).on('change', self.func.validateCheckbox);
                $(self.elements.removalReasonForm).on('submit', self.func.handleContinue);
                $(self.css.removalReason).on('change', self.func.validateDropdownValue);
            },
            handleContinue: function (event) {
                event.preventDefault();
                let dependants = new Array();
                const deceasedDescription = $(self.elements.hiddenField.deceasedDescription).val().trim();
                $('.dependant-details').each(function () {
                    let dateOfDeath = null;
                    let selectedRemovalReason = $(this).find('.removal-reason-select').val();
                    if(selectedRemovalReason.toLowerCase() === deceasedDescription.toLowerCase()){
                    const day = $(this).find('.deceased-day').val().trim();
                    const month = $(this).find('.deceased-month').val().trim();
                    const year = $(this).find('.deceased-year').val().trim();
                    dateOfDeath = `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
                    }
                    let obj = {
                        DependantMembershipNo: $(this).data('entity'),
                        ReasonForLeaving: $(this).find('.removal-reason-select').val(),
                        DateOfDeath: dateOfDeath
                    };
                    dependants.push(obj);
                });
                if (self.func.handleCheckbox()) {
                    $(self.css.invalidDeceasedDateErrorMessage).hide();
                    $(self.css.deceasedDay).removeClass(self.css.invalidTextBoxError);
                    $(self.css.deceasedMonth).removeClass(self.css.invalidTextBoxError);
                    $(self.css.deceasedYear).removeClass(self.css.invalidTextBoxError);
                    self.func.submitFormData(dependants);
                }
            },
            handleCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                    return true;
                } else {
                    $(self.elements.messages.invalidCheckboxError).show();
                    $(self.css.confirmCheckContainer).addClass(self.css.invalidCheckbox);
                    return false;
                }
            },
            validateCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.invalidCheckboxError).hide();
                    $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                }
            },
            validateDropdownValue: function () {
                const dependantCount = $(self.elements.hiddenField.dependantCount).val().trim();
                const deceasedDescription = $(self.elements.hiddenField.deceasedDescription).val().trim();
                for (let i = 1; i <= dependantCount; i++) {
                    const selectedRemovalReasonId = '#removal-reason-form-select-'+i+ ' option:selected';
                    const selectedRemovalReason = $(selectedRemovalReasonId).val().trim();
                    const dateOfDeceasedSection = '#removal-reason-form-date-of-deceased-section-'+i;
                    const dayId = `${self.elements.textBox.dayId}-${i}`;
                    const monthId = `${self.elements.textBox.monthId}-${i}`;
                    const yearId = `${self.elements.textBox.yearId}-${i}`;
                    const invalidDateError = `${self.elements.messages.invalidDateError}-${i}`;
                    if(selectedRemovalReason.toLowerCase() === deceasedDescription.toLowerCase()){
                        $(dateOfDeceasedSection).show();
                        $(dayId).attr('required', true);
                        $(monthId).attr('required', true);
                        $(yearId).attr('required', true);
                    }
                    else{
                        self.func.clearDeceasedDate(dayId, monthId, yearId);
                        $(dateOfDeceasedSection).hide();
                        $(invalidDateError).hide();
                        $(dayId).removeAttr('required');
                        $(monthId).removeAttr('required');
                        $(yearId).removeAttr('required');
                        $(dayId).removeClass(self.css.invalidTextBoxError);
                        $(monthId).removeClass(self.css.invalidTextBoxError);
                        $(yearId).removeClass(self.css.invalidTextBoxError);
                    }
                }
            },
            clearDeceasedDate: function (dayId, monthId, yearId) {
                if ($(dayId).val()) {
                    $(dayId).val('');
                }
                if ($(monthId).val()) {
                    $(monthId).val('');
                }
                if ($(yearId).val()) {
                    $(yearId).val('');
                }
            },
            submitFormData: function (dependants) {
                $.ajax({
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    url: self.urls.sendRemovalReasonFormDetails,
                    data: JSON.stringify({'dependants': dependants}),
                    success: function (response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            window.location.href = self.urls.requestSubmittedPage;
                        }
                        else if (response.statusCode.toLowerCase() === self.statusDescription.badRequest) {
                            for (let error in response.errors) {
                                let errorMessageElementID = `${self.elements.messages.invalidDateError}-${error}`;
                                let dayId = `${self.elements.textBox.dayId}-${error}`;
                                let monthId = `${self.elements.textBox.monthId}-${error}`;
                                let yearId = `${self.elements.textBox.yearId}-${error}`;
                                $(errorMessageElementID).show();
                                $(dayId).addClass(self.css.invalidTextBoxError);
                                $(monthId).addClass(self.css.invalidTextBoxError);
                                $(yearId).addClass(self.css.invalidTextBoxError);
                            }
                        }
                        else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function () {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('removalReason' === $('#removal-reason-form').data('feature')) {
        window.RemovalReasonForm.Init();
    }
});
